// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cb-container {
  display: flex;
  flex-direction: column;
  width: 400px;
  max-width: 400px;
  background-color: var(--cb-white);
  box-shadow: 0px 11.478px 28.694px 2.296px rgba(0, 0, 0, 0.25);
  border-radius: var(--cb-border-radius-lg);
  box-sizing: content-box;
  padding: 0;
  text-align: left;
}

.cb-container-body {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1.5rem;
}

.cb-form {
  display: flex;
  flex-direction: column;
}

.cb-signup-form-submit-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.cb-header {
  display: block;
  text-align: center;
  word-wrap: break-word;
  margin-top: 1.5rem;
  color: var(--cb-header-text-color);
}

.cb-subheader {
  display: block;
  text-align: center;
  margin-bottom: 1rem;
  color: var(--cb-header-text-color);
}

.cb-error-popup {
  display: flex;
  gap: 0.5rem;
  padding: 1rem 2.2rem;
  margin-bottom: -0.75rem;
  background-color: var(--cb-error-popup-background-color);
  border-radius: var(--cb-border-radius-lg) var(--cb-border-radius-lg) 0 0;
}

.cb-error-popup-icon {
  flex: 1;
  margin: auto;
  width: 1.25rem;
  height: 1rem;
}

.cb-error-popup-text-container {
  flex: 11;
  line-height: 1.2rem;
}

.cb-error-popup-text {
  color: var(--cb-error-popup-text-color);
}

.cb-auth-change-section {
  margin: 0.6rem auto 1.5rem auto;
  width: var(--cb-container-wide-width);
}

.cb-disclaimer {
  text-align: center;
  margin: 0.5rem 5rem 0.5rem 5rem;
  line-height: 0.75rem;
}

.cb-spinner {
  margin: auto;
  border: 0.25rem solid transparent;
  border-radius: var(--cb-container-full-width);
  animation: cb-spin-animation 0.75s linear infinite;
}

.cb-initital-loading-spinner {
  border-top-color: var(--cb-primary-color);
  border-right-color: var(--cb-primary-color);
  width: 5rem;
  height: 5rem;
  margin: 4rem auto;
}

@keyframes cb-spin-animation {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}

.cb-row {
  display: flex;
  flex-direction: row;
}

.cb-divider-container {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
  align-self: center;
  width: var(--cb-container-wide-width);
}

.cb-divider-line {
  flex: 1;
  height: 1px;
  background-color: var(--cb-divider-line-color);
}

.cb-divider-text {
  padding: 0 10px;
}

.cb-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--cb-container-full-width);
  height: var(--cb-container-full-width);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.cb-dialog-content {
  background: var(--cb-white);
  padding: 1.5rem;
  border-radius: var(--cb-border-radius-lg);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  width: 290px;
}

.cb-dialog-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0.6rem 0rem 1rem 0rem;
}

.cb-dialog-header-text {
  margin-top: 0rem;
}

.cb-dialog-body {
  margin-bottom: 2.5rem;
}

.cb-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.cb-dialog-x-button {
  cursor: pointer;
  height: 1.5rem;
}

.cb-dialog-button {
  flex: 1;
  margin: auto;
  text-align: center;
}

.cb-error-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0.5rem auto 1.5rem auto;
}

.cb-error-page-body {
  text-align: center;
  margin: 2rem auto 2.25rem auto;
}

@media screen and (max-width: 481px) and (min-width: 400px) {
  .cb-container {
    width: 395px;
  }
}

@media screen and (max-width: 399px) and (min-width: 361px) {
  .cb-container {
    width: 360px;
  }
}

@media screen and (max-width: 360px) {
  .cb-container {
    width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,6DAA6D;EAC7D,yCAAyC;EACzC,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,wDAAwD;EACxD,wEAAwE;AAC1E;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,qCAAqC;EACrC,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,yCAAyC;EACzC,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".cb-container {\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  max-width: 400px;\n  background-color: var(--cb-white);\n  box-shadow: 0px 11.478px 28.694px 2.296px rgba(0, 0, 0, 0.25);\n  border-radius: var(--cb-border-radius-lg);\n  box-sizing: content-box;\n  padding: 0;\n  text-align: left;\n}\n\n.cb-container-body {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 1.5rem;\n}\n\n.cb-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.cb-signup-form-submit-button {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.cb-header {\n  display: block;\n  text-align: center;\n  word-wrap: break-word;\n  margin-top: 1.5rem;\n  color: var(--cb-header-text-color);\n}\n\n.cb-subheader {\n  display: block;\n  text-align: center;\n  margin-bottom: 1rem;\n  color: var(--cb-header-text-color);\n}\n\n.cb-error-popup {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem 2.2rem;\n  margin-bottom: -0.75rem;\n  background-color: var(--cb-error-popup-background-color);\n  border-radius: var(--cb-border-radius-lg) var(--cb-border-radius-lg) 0 0;\n}\n\n.cb-error-popup-icon {\n  flex: 1;\n  margin: auto;\n  width: 1.25rem;\n  height: 1rem;\n}\n\n.cb-error-popup-text-container {\n  flex: 11;\n  line-height: 1.2rem;\n}\n\n.cb-error-popup-text {\n  color: var(--cb-error-popup-text-color);\n}\n\n.cb-auth-change-section {\n  margin: 0.6rem auto 1.5rem auto;\n  width: var(--cb-container-wide-width);\n}\n\n.cb-disclaimer {\n  text-align: center;\n  margin: 0.5rem 5rem 0.5rem 5rem;\n  line-height: 0.75rem;\n}\n\n.cb-spinner {\n  margin: auto;\n  border: 0.25rem solid transparent;\n  border-radius: var(--cb-container-full-width);\n  animation: cb-spin-animation 0.75s linear infinite;\n}\n\n.cb-initital-loading-spinner {\n  border-top-color: var(--cb-primary-color);\n  border-right-color: var(--cb-primary-color);\n  width: 5rem;\n  height: 5rem;\n  margin: 4rem auto;\n}\n\n@keyframes cb-spin-animation {\n  from {\n    transform: rotate(0turn);\n  }\n\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n.cb-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.cb-divider-container {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: 20px 0;\n  align-self: center;\n  width: var(--cb-container-wide-width);\n}\n\n.cb-divider-line {\n  flex: 1;\n  height: 1px;\n  background-color: var(--cb-divider-line-color);\n}\n\n.cb-divider-text {\n  padding: 0 10px;\n}\n\n.cb-dialog {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: var(--cb-container-full-width);\n  height: var(--cb-container-full-width);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.cb-dialog-content {\n  background: var(--cb-white);\n  padding: 1.5rem;\n  border-radius: var(--cb-border-radius-lg);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  width: 290px;\n}\n\n.cb-dialog-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 0.6rem 0rem 1rem 0rem;\n}\n\n.cb-dialog-header-text {\n  margin-top: 0rem;\n}\n\n.cb-dialog-body {\n  margin-bottom: 2.5rem;\n}\n\n.cb-dialog-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.cb-dialog-x-button {\n  cursor: pointer;\n  height: 1.5rem;\n}\n\n.cb-dialog-button {\n  flex: 1;\n  margin: auto;\n  text-align: center;\n}\n\n.cb-error-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin: 0.5rem auto 1.5rem auto;\n}\n\n.cb-error-page-body {\n  text-align: center;\n  margin: 2rem auto 2.25rem auto;\n}\n\n@media screen and (max-width: 481px) and (min-width: 400px) {\n  .cb-container {\n    width: 395px;\n  }\n}\n\n@media screen and (max-width: 399px) and (min-width: 361px) {\n  .cb-container {\n    width: 360px;\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .cb-container {\n    width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
